export const API_URL = process.env.REACT_APP_API_URL ?? 'test_api_url'
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID ?? 'test_client_id'
export const DOMAIN = process.env.REACT_APP_DOMAIN ?? 'test_domain'
export const FPJS_PUBLIC_API_KEY = process.env.REACT_APP_FPJS_PUBLIC_API_KEY ?? 'test_public_key'
